import { render } from "./ObjectProperties.vue?vue&type=template&id=8462cdcc"
import script from "./ObjectProperties.vue?vue&type=script&lang=js"
export * from "./ObjectProperties.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__